import Vue from 'vue';
import VueRouter, {RouteConfig} from 'vue-router';
import Home from '../views/Home.vue';
import AuthorityVue from '@/views/admin/AuthorityVue.vue';
import Login from '@/oauth/Login.vue';
import P404 from '@/views/P404.vue';
import Register from '@/views/Register.vue';
import KeShangRegister from '@/views/KeShangRegister.vue';
import KeShangSelect from '@/views/KeShangSelect.vue';
import KeShangChaXun from '@/views/KeShangChaXun.vue';
import {SecurityUtils} from '@/oauth/SecurityUtils';
import ShenHe from '@/views/admin/ShenHe.vue';
import ZiZhangHao from '@/views/KeShangAdmin/ZiZhangHao.vue';
import KeShangMain from '@/views/KeShangMain.vue';
import CustomerAdminTable from "@/views/KeShangAdmin/CustomerAdminTable.vue";
import EditCustomer from "@/views/KeShangAdmin/EditCustomer .vue";
import CustomerBankForm from "@/components/CustomerBank/CustomerBankForm.vue";
import CustomerBankTable from "@/components/CustomerBank/CustomerBankTable.vue";
import PersonalCenter from "@/views/PersonalCenter.vue";
import Success from "@/views/Success.vue";
import RegisterSuccess from "@/views/RegisterSuccess.vue";
import KeShangSelect1 from "@/views/KeShangSelect1.vue";
import KeShangSelect2 from "@/views/KeShangSelect2.vue";
import QingAppList from "@/views/QingAppList.vue";
import QingAppTable from "@/components/QingApp/QingAppTable.vue";
import PreviewNotPass from "@/views/PreviewNotPass.vue";
import ChatPage from "@/views/ChatPage.vue";
import GroupChat from "@/views/GroupChat.vue";
import RegisterDriver from "@/views/RegisterDriver.vue";
import RegisterDriverSuccess from "@/views/RegisterDriverSuccess.vue";
import PendingNotification from "@/views/PendingNotification.vue";
import AddComments from "@/components/AddComments.vue";
import CommonlyUsedSettings from "@/views/CommonlyUsedSettings.vue";
import Refresh from "@/views/Refresh.vue";
import TimeAssistant from "@/views/AddTimeAssistant.vue";
import TimeAssistantDetails from "@/views/TimeAssistantDetails.vue";
import AddTimeAssistant from "@/views/AddTimeAssistant.vue";
import AllTimeAssistant from "@/views/AllTimeAssistant.vue";
import RealTimeInfoView from "@/views/RealTimeInfoView.vue";
import RealTimeInfoList from '@/views/RealTimeInfoList.vue'
import QingApView from "@/views/QingApView.vue";
import TimeAssistantCollaborat from "@/views/TimeAssistantCollaborat.vue";
import feedback from "@/components/Feedback/feedback.vue";
import MapContainer from "@/views/MapContainer.vue";
import GroupDetails from "@/views/GroupDetails.vue";
import Iframe from "@/components/Iframe/Iframe.vue";
import CheckAgreement from "@/views/CheckAgreement.vue";
import {getModule} from "vuex-module-decorators";
import {AuthStore} from "@/oauth/AuthStore";
import {ajax} from "jquery";
import {User} from "@/oauth/User";
import {NewLoginDto} from "@/dto/NewLoginDto";
import Yszc from "@/views/Yszc.vue";
import Yhxy from "@/views/Yhxy.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
    {
        path: '/',
        name: 'Home',
        component: Home,
    }, {
        path: '/checkAgreement',
        name: 'checkAgreement',
        component: CheckAgreement,
    },
    {
        path: '/authorityvue',
        name: 'authorityvue',
        component: AuthorityVue,
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
    },
    {
        path: '/register',
        name: 'register',
        component: Register,
    },
    {
        path: '/registerDriver',
        name: 'registerDriver',
        component: RegisterDriver,
    },
    {
        path: '/KeShangRegister',
        name: 'KeShangRegister',
        component: KeShangRegister,
    },
    {
        path: '/KeShangSelect',
        name: 'KeShangSelect',
        component: KeShangSelect,
        children: [
            {
                path: '/manageApp/:id',
                name: 'QingAppList',
                component: QingAppList,
            }, {
                path: '/manageAppAdmin',
                name: 'manageAppAdmin',
                component: QingAppTable,
            }, {
                path: '/app/:id',
                name: 'QingAppList',
                component: QingAppList,
            }, {
                path: '/PreviewNotPass',
                name: 'PreviewNotPass',
                component: PreviewNotPass,
            },
        ]
    },
    {
        path: '/KeShangMain',
        name: 'KeShangMain',
        component: KeShangMain,
    },
    {
        path: '/KeShangChaXun/:id',
        name: 'KeShangChaXun',
        component: KeShangChaXun,
    },
    {
        path: '/admin/ShenHe',
        name: 'ShenHe',
        component: ShenHe,
    },
    {
        path: '/KeShangAdmin/ZiZhangHao',
        name: 'ZiZhangHao',
        component: ZiZhangHao,
    },
    {
        path: '/personalCenter',
        name: 'personalCenter',
        component: PersonalCenter,
    },
    {
        path: '/success',
        name: 'success',
        component: Success,
    }, {
        path: '/404',
        name: '404',
        component: P404,
    }, {
        path: '/EditCustomer/:id',
        name: 'EditCustomer',
        component: EditCustomer,
    }, {
        path: '/CustomerAdminTable/:id',
        name: 'CustomerAdminTable',
        component: CustomerAdminTable,
    }, {
        path: '/CustomerBankForm',
        name: 'CustomerBankForm',
        component: CustomerBankForm,
    }, {
        path: '/CustomerBankTable',
        name: 'CustomerBankTable',
        component: CustomerBankTable,
    }, {
        path: '/registerSuccess',
        name: 'registerSuccess',
        component: RegisterSuccess,
    }, {
        path: '/registerDriverSuccess',
        name: 'registerDriverSuccess',
        component: RegisterDriverSuccess,
    }, {
        path: '/keShangSelect1',
        name: 'keShangSelect1',
        component: KeShangSelect1,
    }, {
        path: '/RealTimeInfoView/:id',
        name: 'RealTimeInfoView',
        component: RealTimeInfoView
    }, {
        path: '/RealTimeInfoList',
        name: 'RealTimeInfoList',
        component: RealTimeInfoList
    },
    {
        path: '/keShangSelect2',
        name: 'keShangSelect2',
        component: KeShangSelect2,
    }, {
        path: '/chatPage/:jid,:name',
        name: 'chatPage',
        component: ChatPage,
    }, {
        path: '/groupChat/:id,:jid,:name',
        name: 'groupChat',
        component: GroupChat,
    }, {
        path: '/groupDetails/:id',
        name: 'groupDetails',
        component: GroupDetails,
    }, {
        path: '/pendingNotification/:isread',
        name: 'pendingNotification',
        component: PendingNotification,
    },
    {
        path: '/addComments',
        name: 'addComments',
        component: AddComments,
    },
    {
        path: '/commonlyUsedSettings',
        name: 'commonlyUsedSettings',
        component: CommonlyUsedSettings
    },
    {
        path: '/refresh',
        name: 'refresh',
        component: Refresh
    },
    {
        path: '/addTimeAssistant',
        name: 'addTimeAssistant',
        component: AddTimeAssistant
    },
    {
        path: '/timeAssistantDetails/:id',
        name: 'timeAssistantDetails',
        component: TimeAssistantDetails
    },
    {
        path: '/allTimeAssistant',
        name: 'allTimeAssistant',
        component: AllTimeAssistant
    }, {
        path: '/qingAppView',
        name: 'qingAppView',
        component: QingApView
    }, {
        path: '/timeAssistantCollaborat/:id',
        name: 'timeAssistantCollaborat',
        component: TimeAssistantCollaborat
    }, {
        path: '/feedback/:id',
        name: 'feedback',
        component: feedback
    }, {
        path: '/mapContainer',
        name: 'mapContainer',
        component: MapContainer
    }, {
        path: '/iframe/:url',
        name: 'iframe',
        component: Iframe
    }, {
        path: '/yszc',
        name: 'yszc',
        component: Yszc
    }, {
        path: '/yhxy',
        name: 'yhxy',
        component: Yhxy
    }
];

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        return {x: 0, y: 0}
    }
});

router.beforeEach(async (to, from, next) => {
    const a = getModule(AuthStore)
    const authToken = window.localStorage.getItem("AuthToken") as any
    const authToken1 = JSON.parse(authToken)
    if (authToken1 !== null) {
        const token = authToken1.access_token
        const res = await NewLoginDto.queryUserInfoByToken(token) as any
        if (res.resCode === '200') {
            a.setLoginUser(res.data)
        }
    }
    if (['yszc', 'yhxy', 'login', 'checkAgreement', 'Home', 'register', 'registerSuccess', 'registerDriver', 'registerDriverSuccess', 'iframe'].some(value => to.name === value)) {
        next();
    } else {
        if (!SecurityUtils.isLoggedIn()) {
            localStorage.setItem('entryPoint', JSON.stringify(to));
            next({name: 'login'});
        }
    }
    next();
});
export default router;
